export const PRODUCT_PREVIEW_SIZE = {
  collapsed: 'collapsed',
  expanded: 'expanded'
}
